export enum AnalyticsStatus {
  OK = 'ok',
  NO_TRANSACTIONS = 'no_transactions',
  NO_ANALYTICS_FOR_PERIOD = 'no_analytics_for_period',
  PROVIDER_TAX_LOT_ERROR = 'provider_tax_lot_error',
  ERROR = 'error'
}

export enum AnalyticsField {
  DATE = 'date',

  REPO_ROOT = 'repo_root',
  ROOT_ID = 'root_id',

  ASSET = 'asset',
  ASSET_ID = 'asset_id',
  ASSET_NAME = 'asset_name',
  ASSET_TYPE = 'asset_type',
  ASSET_TICKER = 'asset_ticker',

  ACCOUNT = 'account',
  ACCOUNT_ID = 'account_id',
  ACCOUNT_NAME = 'account_name',
  ACCOUNT_TYPE = 'account_type',
  ACCOUNT_TICKER = 'account_ticker',

  CATEGORY = 'Category',
  SUBCATEGORY = 'Subcategory',

  TAGS = 'tags',

  AMOUNT = 'amount',

  POSITION_CLOSE = 'position_close',
  POSITION_COST = 'position_cost',
  POSITION_GAIN = 'position_gain',

  // Income
  CATEGORY_ACCOUNT = 'category_account',
  CATEGORY_ACCOUNT_ID = 'category_account_id',
  CATEGORY_ACCOUNT_NAME = 'category_account_name',
  CATEGORY_ACCOUNT_TYPE = 'category_account_type',

  // Position
  ASSET_CLOSE = 'asset_close',
  ASSET_GAIN = 'asset_gain',
  ASSET_COST = 'asset_cost',

  // Value Change
  D_POSITION_CLOSE = 'd_position_close',
  D_POSITION_COST = 'd_position_cost',
  D_POSITION_GAIN = 'd_position_gain',

  D_AMOUNT = 'd_amount',

  // Performance
  VALUE_START = 'value_start',
  CAPITAL_FLOW = 'capital_flow',
  CHANGE = 'change',
  PERCENT_CHANGE = 'percent_change',
  VALUE_END = 'value_end',
  IRR = 'irr',
  MOIC = 'moic',
  REALIZED_GAIN = 'realized_gain_income',
  UNREALIZED_GAIN = 'unrealized_gain_income',
  REALIZED_GAIN_PROVIDER = 'realized_gain_provider',
  UNREALIZED_GAIN_PROVIDER = 'unrealized_gain_provider',
  INVESTMENT_INCOME = 'investment_income',
  GAIN_OR_LOSS = 'gain_or_loss',
  // Derived in DuckDB per aggregation level, not emitted by the backend.
  // Captioned "Investment Return"; the key stays income_return so saved pivot
  // configs, which persist field names, keep resolving their column.
  INCOME_RETURN = 'income_return',
  TOTAL_RETURN = 'total_return',

  // Commitments
  INCEPTION_DATE = 'inception_date',
  ORIGINAL_COMMITMENT = 'original_commitment',
  REMAINING_COMMITMENT = 'remaining_commitment',
  INVESTED_CAPITAL = 'invested_capital',
  RECALLABLE_CAPITAL = 'recallable_capital',
  RETURNED_CAPITAL = 'returned_capital',
  INCOME = 'income',
  TOTAL_DISTRIBUTION = 'total_distribution',
  GAIN_LOSS = 'gain_loss',
  CURRENT_BALANCE = 'current_balance'
}
